module.exports = __webpack_public_path__ + "img/break.c8647a2e.svg";